import myHeader from "../../components/header.vue"

export default{
    components: {
        myHeader
      },
}


// WEBPACK FOOTER //
// ./src/pages/banner2/banner.js